var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-back-btn",attrs:{"shape":"circle"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('a-icon',{style:({fontSize: '26px'}),attrs:{"type":"rollback"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }